(function () {
  'use strict';

  async function initialise() {
    var root = document.querySelector('[data-best-results]');
    var selector = document.querySelector('[data-best-selector]');
    if (!root || !selector || root.dataset.bestReady) return;
    root.dataset.bestReady = 'true';
    var buttons = Array.from(selector.querySelectorAll('[data-best-group]'));
    var groups = new Map(buttons.map(function (button) { return [button.dataset.bestGroup, button.dataset.bestLabel]; }));
    var sources = new Map(buttons.map(function (button) { return [button.dataset.bestGroup, (button.dataset.bestSources || '').split(' ')]; }));
    var form = root.querySelector('[data-aquatic-filters]');
    var catalogue = root.querySelector('[data-best-catalogue]');
    var grid = root.querySelector('.mas-aquatic__grid');
    var count = root.querySelector('[data-best-count]');
    var active = root.querySelector('[data-best-active]');
    var empty = root.querySelector('[data-best-empty]');
    var pagination = root.querySelector('[data-best-pagination]');
    var nativePagination = root.querySelector('.mas-aquatic__pagination:not([data-best-pagination])');
    var nativeEmpty = root.querySelector('.mas-aquatic__empty:not([data-best-empty])');
    var pageSize = Math.max(1, Number(root.dataset.bestPageSize) || 30);
    var cards = Array.from(root.querySelectorAll('[data-best-product]'));
    var groupInput = document.createElement('input');
    groupInput.type = 'hidden';
    groupInput.name = 'group';
    form.appendChild(groupInput);
    var group = '';
    var page = 1;

    function readLocation() {
      var params = new URL(window.location.href).searchParams;
      group = groups.has(params.get('group')) ? params.get('group') : '';
      page = Math.max(1, Math.floor(Number(params.get('best_page')) || 1));
    }

    function locationFor(nextGroup, nextPage) {
      var url = new URL(window.location.href);
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      if (nextGroup) url.searchParams.set('group', nextGroup);
      else url.searchParams.delete('group');
      if (nextPage > 1) url.searchParams.set('best_page', String(nextPage));
      else url.searchParams.delete('best_page');
      return url;
    }

    function appendPageLink(label, target, accessibleLabel) {
      var link = document.createElement('a');
      var url = locationFor(group, target);
      url.hash = root.id;
      link.href = url.toString();
      link.textContent = label;
      link.dataset.bestPageLink = String(target);
      link.setAttribute('aria-label', accessibleLabel);
      pagination.appendChild(link);
    }

    function render() {
      var matching = cards.filter(function (card) {
        var memberships = card.dataset.bestGroups.split(' ');
        return !group || sources.get(group).some(function (handle) { return memberships.includes(handle); });
      });
      var pages = Math.max(1, Math.ceil(matching.length / pageSize));
      page = Math.min(page, pages);
      var start = (page - 1) * pageSize;
      var visible = new Set(matching.slice(start, start + pageSize));
      cards.forEach(function (card) { card.hidden = !visible.has(card); });
      buttons.forEach(function (button) {
        var selected = button.dataset.bestGroup === group;
        button.setAttribute('aria-pressed', String(selected));
        button.classList.toggle('is-current', selected);
      });
      var label = groups.get(group);
      count.textContent = matching.length + (matching.length === 1 ? ' product' : ' products') +
        (group ? ' · ' + label : '') +
        (pages > 1 ? ' · Showing ' + (start + 1) + '–' + Math.min(start + pageSize, matching.length) : '');
      active.hidden = !group;
      active.querySelector('button').textContent = (label || '') + ' ×';
      active.querySelector('button').setAttribute('aria-label', 'Remove category: ' + (label || 'All'));
      groupInput.value = group;
      groupInput.disabled = !group;
      empty.hidden = !cards.length || !!matching.length;
      if (grid) grid.hidden = !matching.length;
      if (nativeEmpty && cards.length) nativeEmpty.hidden = true;
      if (nativePagination) nativePagination.hidden = true;

      // Native price/stock facet removals keep the current category. Clear all resets it.
      root.querySelectorAll('.mas-aquatic__active-filters a').forEach(function (link) {
        var url = new URL(link.href);
        url.searchParams.delete('best_page');
        if (group && !link.classList.contains('mas-aquatic__clear')) url.searchParams.set('group', group);
        else url.searchParams.delete('group');
        link.href = url.toString();
      });

      pagination.replaceChildren();
      pagination.hidden = pages <= 1;
      if (pages > 1) {
        if (page > 1) appendPageLink('←', page - 1, 'Previous page');
        for (var number = 1; number <= pages; number++) {
          if (number !== 1 && number !== pages && Math.abs(number - page) > 1) {
            if (number === page - 2 || number === page + 2) {
              var ellipsis = document.createElement('span');
              ellipsis.textContent = '…';
              pagination.appendChild(ellipsis);
            }
            continue;
          }
          if (number === page) {
            var current = document.createElement('span');
            current.textContent = String(number);
            current.setAttribute('aria-current', 'page');
            pagination.appendChild(current);
          } else appendPageLink(String(number), number, 'Go to page ' + number);
        }
        if (page < pages) appendPageLink('→', page + 1, 'Next page');
      }
    }

    function choose(nextGroup, nextPage, scroll) {
      group = nextGroup;
      page = nextPage;
      render();
      var url = locationFor(group, page);
      if (scroll) url.hash = root.id;
      window.history.pushState(null, '', url);
      if (scroll) {
        root.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        count.setAttribute('tabindex', '-1');
        count.focus({ preventScroll: true });
      }
    }

    // Load every server page before filtering; membership must never depend on which
    // catalogue page the customer happened to open. Normal Best Sellers fits in one.
    try {
      var currentServerPage = Number(catalogue.dataset.bestPage) || 1;
      var serverPages = Math.max(1, Number(catalogue.dataset.bestPages) || 1);
      if (serverPages > 1 || currentServerPage > 1) {
        root.setAttribute('aria-busy', 'true');
        var pages = new Map([[currentServerPage, cards]]);
        for (var serverPage = 1; serverPage <= serverPages; serverPage++) {
          if (serverPage === currentServerPage) continue;
          var url = new URL(window.location.href);
          url.hash = '';
          url.searchParams.delete('best_page');
          url.searchParams.set(catalogue.dataset.bestPageParam || 'page', String(serverPage));
          url.searchParams.set('section_id', root.dataset.bestSection);
          var response = await fetch(url.toString(), { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Catalogue page unavailable');
          var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          var results = doc.querySelector('[data-best-results]');
          if (!results || results.dataset.bestSection !== root.dataset.bestSection) throw new Error('Unexpected catalogue response');
          pages.set(serverPage, Array.from(results.querySelectorAll('[data-best-product]')).map(function (card) { return document.importNode(card, true); }));
        }
        cards = [];
        for (var index = 1; index <= serverPages; index++) cards.push.apply(cards, pages.get(index) || []);
        if (cards.length !== Number(root.dataset.bestTotal)) throw new Error('Incomplete catalogue');
        if (!grid) {
          var favourites = document.createElement('div');
          favourites.setAttribute('data-mas-favourites', '');
          grid = document.createElement('div');
          grid.className = 'mas-aquatic__grid';
          favourites.appendChild(grid);
          catalogue.after(favourites);
        }
        grid.replaceChildren.apply(grid, cards);
        var section = root.closest('.shopify-section');
        if (section) section.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      }
      root.removeAttribute('aria-busy');
    } catch (error) {
      root.removeAttribute('aria-busy');
      root.dataset.bestReady = 'error';
      var notice = document.createElement('p');
      notice.setAttribute('role', 'alert');
      notice.textContent = 'Category filters could not load. Refresh the page to try again.';
      count.after(notice);
      return;
    }

    readLocation();
    render();
    window.history.replaceState(null, '', locationFor(group, page));
    selector.hidden = false;
    buttons.forEach(function (button) {
      button.addEventListener('click', function () { choose(button.dataset.bestGroup, 1, false); });
    });
    root.querySelectorAll('[data-best-clear-group]').forEach(function (button) {
      button.addEventListener('click', function () {
        choose('', 1, false);
        selector.querySelector('[data-best-group=""]').focus({ preventScroll: true });
      });
    });
    pagination.addEventListener('click', function (event) {
      var link = event.target.closest('[data-best-page-link]');
      if (!link || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      choose(group, Number(link.dataset.bestPageLink), true);
    });
    window.addEventListener('popstate', function () { if (root.isConnected) { readLocation(); render(); } });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
}());

